export default [
  {
    name: 'Y1',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/cloudBanner.png',
    imgStyle: 'width: 597px;left: 75px;height: 107px;top: 42px;'
  },
  {
    name: 'Y2',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/cloudDialog.png',
    imgStyle: 'width: 397px;left: 176px;top: 114px;height: 247px;',
    panelStyle: 'height: 530px;'
  },
  {
    name: 'Y3',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/cloudAdvertising.png',
    imgStyle: 'width: 91px;left: 635px;top: 302px;height: 99px;',
    panelStyle: 'height: 430px;'
  },
  {
    name: 'D1',
    backgroundImageUrl: '',
    imgStyle: 'width: 100%;height: 100%;'
  },
  {
    name: 'D2',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/myShop.png',
    imgStyle: 'width: 223px;left: 39px;top: 110px;height: 309px;',
    panelStyle: 'width: 300px;margin: auto;'
  },
  {
    name: 'G1',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/officialSiteBanner.png',
    imgStyle: 'width: 749px;top: 42px;height: 349px;',
    panelStyle: 'height: 510px;'
  },
  {
    name: 'G2',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/officialSiteBanner.png',
    imgStyle: 'width: 762px;left: -2px;top: 49px;height: 412px;'
  },
  {
    name: 'G3',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/officialSiteBanner.png',
    imgStyle: 'width: 762px;left: -2px;top: 49px;height: 412px;'
  },
  {
    name: 'G4',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/officialSiteBanner.png',
    imgStyle: 'width: 762px;left: -2px;top: 49px;height: 412px;'
  },
  {
    name: 'G5',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/officialSiteBanner.png',
    imgStyle: 'width: 762px;left: -2px;top: 49px;height: 412px;'
  },
  {
    name: 'G6',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/mobile.png',
    imgStyle: 'width: 223px;left: 39px;top: 109px;height: 332px;',
    panelStyle: 'margin: auto;width: 300px;'
  },
  {
    name: 'G8',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/officialSiteLogin.png',
    imgStyle: 'z-index: 1;top: 73px;left: -2px;width: 1564px;height: 461px;'
  },
  {
    name: 'G9',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/officialSiteLogin.png',
    imgStyle: 'z-index: 1;top: 73px;left: -2px;width: 1564px;height: 461px;'
  },
  {
    name: 'G10',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/officialSiteLogin.png',
    imgStyle: 'z-index: 1;top: 73px;left: -2px;width: 1564px;height: 461px;'
  },
  {
    name: 'G11',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/officialSiteLogin.png',
    imgStyle: 'z-index: 1;top: 73px;left: -2px;width: 1564px;height: 461px;'
  },
  {
    name: 'G12',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/officialSiteRegister.png',
    imgStyle: 'z-index: 1;top: 73px;left: -2px;width: 1564px;height: 461px;'
  },
  {
    name: 'G13',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/officialSiteRegister.png',
    imgStyle: 'z-index: 1;top: 73px;left: -2px;width: 1564px;height: 461px;'
  },
  {
    name: 'G14',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/officialSiteRegister.png',
    imgStyle: 'z-index: 1;top: 73px;left: -2px;width: 1564px;height: 461px;'
  },
  {
    name: 'G15',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/officialSiteRegister.png',
    imgStyle: 'z-index: 1;top: 73px;left: -2px;width: 1564px;height: 461px;'
  },
  {
    name: 'L1',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/pospalLeague.png',
    imgStyle: 'top: 64px;left: -3px;width: 303px;;height: 149px;',
    panelStyle: 'width: 300px;margin: auto;'
  },
  {
    name: 'L2',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/pospalLeague.png',
    imgStyle: 'top: 64px;left: -3px;width: 303px;;height: 149px;',
    panelStyle: 'width: 300px;margin: auto;'
  },
  {
    name: 'L3',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/pospalLeague.png',
    imgStyle: 'top: 64px;left: -3px;width: 303px;;height: 149px;',
    panelStyle: 'width: 300px;margin: auto;'
  },
  {
    name: 'L4',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/pospalLeague.png',
    imgStyle: 'top: 64px;left: -3px;width: 303px;;height: 149px;',
    panelStyle: 'width: 300px;margin: auto;'
  },
  {
    name: 'L5',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/pospalLeague.png',
    imgStyle: 'top: 64px;left: -3px;width: 303px;;height: 149px;',
    panelStyle: 'width: 300px;margin: auto;'
  },
  {
    name: 'L6',
    backgroundImageUrl: '',
    imgStyle: 'width: 300px;height: 533px;margin-left: calc(50% - 150px);'
  },
  {
    name: 'S1',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/feedbackChannel.png',
    imgStyle: 'top: 64px;left: -3px;width: 293px;height: 111px;',
    panelStyle: 'width: 300px;margin: auto;'
  },
  {
    name: 'S2',
    backgroundImageUrl: '//imgw.pospal.cn/we/advertisingPlatform/preview/feedbackChannel.png',
    imgStyle: 'top: 64px;left: -3px;width: 293px;height: 111px;',
    panelStyle: 'width: 300px;margin: auto;'
  }
]
